export default __webpack_public_path__ + "static/media/img-0460-montenegro-full-face.18c797b5.png";